import {subscribeAndGetFullContent} from '@api/preview';
import Fade from '@components/Animation/Fade';
import ButtonFill from '@components/ButtonFill';
import ErrorableField from '@components/Formik/ErrorableField';
import FormikErrorMessage from '@components/Formik/ErrorMessage';
import validationSchema from '@components/Preview/SubscriberPreview/validationSchema';
import {EMAIL} from '@constants/subscription';
import type {GetFullContentResponse} from '@interfaces/PreviewWidget';
import Analytics from '@services/analytics/Analytics';
import {isValid} from '@utils/formikUtils';
import type {FormikBag, FormikProps} from 'formik';
import {Form, Formik} from 'formik';
import type {ReactElement} from 'react';
import I18n from '@components/I18n';
import {localize} from '@services/i18n';

interface Props {
    code: string;

    onSubmit(data: string): void;
}

interface Values {
    [EMAIL]: string;
}

export default function SubscriptionForm(props: Props): ReactElement<Props> {
    function handleSubmit(values: Values, formikBag: FormikBag<Props, Values>) {
        formikBag.setSubmitting(true);
        subscribeAndGetFullContent(props.code, values[EMAIL])
            .then((response: GetFullContentResponse) => {
                if (response.data.wasSubscriptionCreated) {
                    Analytics.triggerEvent('Успешная бесплатная подписка', 'subscribe', {
                        code: props.code,
                    });
                }

                props.onSubmit(response.data.content);
            })
            .catch((error: unknown) => {
                formikBag.setFieldError(EMAIL, localize('Preview_emailError'));
                console.error(error);
            })
            .finally(() => {
                formikBag.setSubmitting(false);
            });
    }

    return (
        <Formik
            enableReinitialize
            initialValues={{
                [EMAIL]: '',
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
        >
            {(formik: FormikProps<Values>) => (
                <Form className="preview-subscription-form">
                    <ErrorableField
                        type={EMAIL}
                        name={EMAIL}
                        placeholder="email"
                        className="preview-subscription-form__input"
                    />
                    <div className="preview-subscription-form__error-container">
                        <Fade in={!isValid(formik)} unmountOnExit>
                            <FormikErrorMessage className="preview-subscription-form__error" />
                        </Fade>
                    </div>
                    {!formik.isSubmitting && (
                        <ButtonFill
                            type="submit"
                            className="js-track-newsletter-subscribe-preview preview-subscription-form__submit"
                            disabled={!isValid(formik)}
                        >
                            <I18n code="Preview_subscribeSubmit" />
                        </ButtonFill>
                    )}
                    {formik.isSubmitting ? (
                        <div className="preview-subscription-form__loading">
                            <div className="loading-spinner" />
                        </div>
                    ) : null}
                </Form>
            )}
        </Formik>
    );
}
